import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const channelSlice = createAppSlice({
  name: 'channel',
  initialState,
  reducers,
});

export const { fetchRegistrationQuestions } = channelSlice.actions;

export default channelSlice.reducer;
